import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FinanceService } from '../../../services/finance.service'
import { UserSessionService } from '../../../services/user-session.service'
import { StockService } from '../../../services/stock.service'
import { LibService } from '../../../services/libService'
import { ToastrService } from 'ngx-toastr';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SearchOrderService } from '../../providers/search-order.service';

@Component({
  selector: 'planner-search',
  templateUrl: './planner-search.component.html',
  styleUrls: ['./planner-search.component.scss'],
})
export class PlannerSearchComponent {
  currentOrder: any;
  searchForm: UntypedFormGroup;
  @Input() plannerType: any = 'core';

  constructor(
    private userSessionService: UserSessionService,
    private fb: UntypedFormBuilder,
    public translate: TranslateService,
    private searchOrderService: SearchOrderService,
  ) {}

  ngOnInit() {
    this.searchForm = this.fb.group({
      code: [null, [Validators.required]],
    });
    this.searchOrderService.code$.subscribe((code) => {
      if(code !== "") {
        this.searchForm.controls['code'].setValue(code);
        this.search();
      }
    });
  }

  getCompany() {
    const company = this.userSessionService.getState('working_company');
    if (!(company == null) && !(company.name == '*')) {
      return company.id;
    } else return 0;
  }

  search() {
    let currentUser = this.userSessionService.getState('user');
    let code = this.searchForm.controls['code'].value;
    let companyId = this.getCompany();
    this.searchOrderService.search(currentUser.email, companyId, code, this.plannerType);
  }
}
